import React from "react";
import Bioblinds from "./Bioblinds";
import Gallery from "./Gallery";
import Videos from "./Videos";
import Layout from "./../Layout/Layout";

const Index = () => {
  return (
    <Layout>
      <Bioblinds />
      <Gallery />
      <Videos />
    </Layout>
  );
};

export default Index;
